import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { userRequest } from "../../../utils/requestMethods";
import { Header, CustomPagination, SkeletonTable, AlertNotification } from "../../../components";
import { useStateContext } from "../../../contexts/ContextProvider";
import { MdSearch } from "react-icons/md";

const customStyles = {
  headRow: {
    style: {
      backgroundColor: "rgb(248, 250, 252)",
      fontWeight: "bold",
    },
  },
};

const ResultsClasses = ({ history }) => {
  const { user, school } = useStateContext();
  const schoolId = school?._id;
  //const schoolCode = school?.code;
  const [classes, setClasses] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAssignedClass();
  }, [schoolId]);

  const fetchAssignedClass = async () => {
    setLoading(true);
    try {
      const { data } = await userRequest.get(
        `/teachers/teacher-assigned-classes/${school?._id}/${user?._id}?limit=50`,
      );
      console.log(data.classes);
      setClasses(data.classes || []);
    } catch (error) {
      console.error("Error fetching Assigned Class:", error);
      setError("Error fetching Assigned Class");
      setClasses([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Class Name",
      selector: (row) => (
        <div className="flex items-center gap-1.5 py-1">
          <span className="font-semibold text-slate-800">{row.class_name}</span>
          {row.group_label && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 font-medium border border-indigo-200">
              Arm {row.group_label}
            </span>
          )}
        </div>
      ),
    },
    {
      name: "Level of Education",
      selector: (row) => row.level_of_education,
    },
    {
      name: "Teacher Role",
      selector: (row) => {
        const role = row.teacher_role || "N/A";
        return (
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${
              role === "primary"
                ? "bg-indigo-100 text-indigo-800"
                : role === "assistant"
                  ? "bg-purple-100 text-purple-800"
                  : "bg-gray-100 text-gray-800"
            }`}
          >
            {role === "primary"
              ? "Primary Teacher"
              : role === "assistant"
                ? "Assistant Teacher"
                : "Teacher"}
          </span>
        );
      },
    },
    {
      name: "Total Students",
      selector: (row) => row.total_students,
    },
    {
      name: "Action",
      cell: (row) => (
        <Link
          to={{ pathname: `/t/results/students/${row._id}`, state: { student: row } }}
          className="font-medium text-[#00509D] hover:underline"
        >
          View Students
        </Link>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  const filteredData = classes?.filter(
    (item) => item.class_name?.toLowerCase().includes(filterText.toLowerCase()) || "",
  );

  return (
    <>
      <div className="px-3 md:px-10 pt-10 md:pt-5 mt-10">
        <div className="flex flex-wrap justify-between items-center mb-4">
          <Header category="Results" title="Assigned Classes" />
        </div>
      </div>

      <div className="m-2 md:mx-10 p-4 md:p-10 bg-white rounded-3xl dark:bg-secondary-dark-bg min-h-screen">
        <div className="flex flex-wrap justify-between items-center mb-4">
          <h1
            className="text-lg font-semibold w-full md:w-auto mb-2 md:mb-0"
            style={{ maxWidth: "20em" }}
          >
            Assigned Classes
          </h1>
          <div className="flex flex-wrap justify-center md:justify-end w-full md:w-auto gap-2">
            {/* Search Input */}
            <form className="w-full md:w-auto">
              <div className="relative">
                <div className="absolute inset-y-0 start-0 flex items-center pl-4 pointer-events-none">
                  <MdSearch />
                </div>
                <input
                  type="text"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  className="w-full sm:w-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm sm:text-md rounded-full focus:ring-blue-500 focus:border-blue-500 block pl-8 p-2.5"
                  placeholder="Search"
                />
              </div>
            </form>
          </div>
        </div>
        <div className="border rounded-3xl">
          <DataTable
            data={filteredData}
            columns={columns}
            getRowId={(row) => row._id}
            pagination
            paginationComponent={CustomPagination}
            customStyles={customStyles}
            progressPending={loading}
            progressComponent={<SkeletonTable rows={5} columns={6} />}
            highlightOnHover
            striped
            onRowClicked={(row) => {
              history.push({
                pathname: `/t/results/students/${row._id}`,
                state: { student: row },
              });
            }}
            pointerOnHover
          />
        </div>
        {error && <AlertNotification type="error" message={error} onClose={() => setError("")} />}
      </div>
    </>
  );
};
export default ResultsClasses;
